import { useCallback } from 'react';

import { useTogglePlay } from '@/scenarios/legacy-player/hooks/useTogglePlay';
import { PlayingState } from '@/scenarios/legacy-player/types/instance';

import { useUserActionIndicatorChangers } from './use-user-action-indicator';

export const useTogglePlayWithIndicator = (): {
    play: () => void;
    pause: () => void;
    togglePlay: () => PlayingState.play | PlayingState.pause | undefined;
} => {
    const { togglePlay, play, pause } = useTogglePlay();
    const { showPlay, showPause } = useUserActionIndicatorChangers();

    const togglePlayWithIndicator = useCallback(() => {
        const targetPlayingState = togglePlay();

        if (targetPlayingState === PlayingState.play) {
            showPlay();
        }

        if (targetPlayingState === PlayingState.pause) {
            showPause();
        }

        return targetPlayingState;
    }, [togglePlay, showPause, showPlay]);

    const playWithIndicator = useCallback(() => {
        play();
        showPlay();
    }, [play, showPlay]);

    const pauseWithIndicator = useCallback(() => {
        pause();
        showPause();
    }, [pause, showPause]);

    return {
        togglePlay: togglePlayWithIndicator,
        play: playWithIndicator,
        pause: pauseWithIndicator,
    };
};
